import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Row, Col, Card, Result, Avatar, Divider, Space, Grid } from 'antd';
import { Button, Input, Tag } from 'antd';
import { useNavigate, useLocation, Link } from 'react-router-dom';

// actions

import { checkModulePermissions } from '../../utils/helper';
import HeaderFile from '../../components/Header/HeaderFile';

import Header from '../../components/Header/Header';

import FilingManagement from './PreServiceFilingManagement';
import TabPane from 'antd/es/tabs/TabPane';
import { getCountByFilingAndRevenueApi } from '../../actions/getCountByFilingAndRevenueAction';
import {
	XThemeCardTitle1,
	XThemeCardTitle2,
} from '../Dashboard/DashboardStyle';
import {
	XTheme2IndividualInnerCard,
	XTheme2InnerCard,
	XTheme2Para1,
	XThemeDashboardLottieCard,
} from '../Dashboard/DashboardStyleCQ';
import { PlusCircleFilled, PlusOutlined } from '@ant-design/icons';
import {
	XTheme2Button,
	XTheme2CustomTabsTable,
	XTheme2MainTitle,
	XTheme2TableCard,
	XThemeContainer,
} from '../../styles/GlobalThemeStyleCQ';
import DashboardJson from '../../json/Reclaim.json';
import PreServiceFilingManagement from './PreServiceFilingManagement';

const CaseManagement = (props) => {
	const { getCountByFilingAndRevenueState, getCountByFilingAndRevenue } =
		props;
	const navigate = useNavigate();
	const location = useLocation();

	const [activeTab, setActiveTab] = useState('all');
	const [filingStatusCount, setFilingStatusCount] = useState({
		escalation: 0,
		at_risk: 0,
		in_process: 0,
		untimely: 0,
	});
	const [filingStatus, setFilingStatus] = useState();
	const [revenueCycleCount, setRevenueCycleCount] = useState({
		pre_service: 0,
		post_claim: 0,
		part_b_drugs: 0,
		all: 0,
	});
	const [appealLetterApprovals, setAppealLetterApprovals] = useState(0);
	const onChange = (key) => {
		// Update the URL with the selected tab's value
		const queryParams = new URLSearchParams(window.location.search);
		queryParams.set('revenue_cycle', key);

		// Update other query parameters as needed
		queryParams.set('page', '1');
		queryParams.set('sort', 'createdAt');
		queryParams.set('sortDirection', 'descend');

		// Construct the new URL
		const newUrl = `${window.location.pathname}?${queryParams.toString()}`;

		// Push the new URL to the browser history
		window.history.pushState({}, '', newUrl);

		// Optionally, you can set the active tab state here if needed
		setActiveTab(key);
	};

	const handleClick = (filing_status) => {
		// Update the URL with the filing status
		const queryParams = new URLSearchParams(window.location.search);
		queryParams.set('filing_status', filing_status); // Assuming 'filing_status' is the query parameter to store the filing status

		// Construct the new URL
		const newUrl = `${window.location.pathname}?${queryParams.toString()}`;

		// Push the new URL to the browser history
		window.history.pushState({}, '', newUrl);
		setFilingStatus(filing_status);
		// window.location.reload();
	};

	const items = [
		{
			key: 'all',
			label: (
				<>
					All - <span>{revenueCycleCount.all}</span>
				</>
			),
			children: <FilingManagement filingStatus={filingStatus} />,
		},
		{
			key: 'pre_service',
			label: (
				<>
					Pre-Service - <span>{revenueCycleCount.pre_service}</span>
				</>
			),
			children: <FilingManagement filingStatus={filingStatus} />,
		},
		{
			key: 'post_claim',
			label: (
				<>
					Post Claim - <span>{revenueCycleCount.post_claim}</span>
				</>
			),
			children: <FilingManagement filingStatus={filingStatus} />,
		},
		{
			key: 'part_b_drugs',
			label: (
				<>
					Part B Drugs - <span>{revenueCycleCount.part_b_drugs}</span>
				</>
			),
			children: <FilingManagement filingStatus={filingStatus} />,
		},
		checkModulePermissions('appeal-letter').sub_modules.includes(
			'confirm-letter',
		) && {
			key: 'appeal_letter_approvals',
			label: (
				<>
					Appeal letter Approvals -
					<span>{appealLetterApprovals}</span>
				</>
			),
			children: (
				<FilingManagement filingStatus={'appeal_letter_approvals'} />
			),
		},
	];

	useEffect(() => {
		const searchParams = new URLSearchParams(location.search);
		const activeTabFromUrl = searchParams.get('revenue_cycle');
		getCountByFilingAndRevenue();
		if (
			activeTabFromUrl &&
			items.some((item) => item.key === activeTabFromUrl)
		) {
			setActiveTab(activeTabFromUrl);
		}
	}, [location.search]);

	useEffect(() => {
		if (getCountByFilingAndRevenueState.apiState === 'success') {
			const data = getCountByFilingAndRevenueState.data;

			// Initialize an object to hold the updated counts
			const updatedRevenueCycleCount = {
				pre_service: 0,
				post_claim: 0,
				part_b_drugs: 0,
				all: 0,
			};
			const updatedFilingStatusCount = {
				escalation: 0,
				at_risk: 0,
				in_process: 0,
				untimely: 0,
			};

			// Iterate through the revenue_cycle array and update the counts
			data.revenue_cycle.forEach((item) => {
				updatedRevenueCycleCount[item._id] = item.count;
			});

			// Update the state with the new counts
			setRevenueCycleCount(updatedRevenueCycleCount);

			setAppealLetterApprovals(data.pending_appeal_letter_approvals);

			// Iterate through the revenue_cycle array and update the counts
			data.filing_status.forEach((item) => {
				updatedFilingStatusCount[item._id] = item.count;
			});

			// Update the state with the new counts
			setFilingStatusCount(updatedFilingStatusCount);
		}
	}, [getCountByFilingAndRevenueState]);

	// use effects
	const { useBreakpoint } = Grid;
	const screens = useBreakpoint();
	const isMobile = !screens.md;
	return (
		<>
			{props.displayHeader ? (
				<></>
			) : (
				<>
					<Col lg={24} xl={24} xs={0} md={0}>
						<Header
							headerTag={
								location.pathname.startsWith('/coding-team')
									? 'Coding Team'
									: location.pathname.startsWith(
											'/case-filing-management',
									  )
									? 'Case Filing'
									: location.pathname.startsWith(
											'/md-advisor',
									  )
									? 'MD Advisor'
									: ''
							}
						/>
					</Col>
					<Col lg={0} xl={0} xs={24} md={24}>
						<HeaderFile activeNav="caseManagement" />
					</Col>
				</>
			)}
			{checkModulePermissions('case-filing').sub_modules.includes(
				'list-cases',
			) ? (
				<XThemeContainer fluid>
					<Row gutter={[15, 15]} className="align-items-center mb-4">
						{/* <Col
							xs={24}
							sm={24}
							md={3}
							lg={2}
							className="text-center"
						>
							<XThemeDashboardLottieCard
								className="caseManagementTitleAnimation"
								animationData={DashboardJson}
								loop={true}
							/>
						</Col> */}
						<Col
							xs={24}
							sm={24}
							md={12}
							lg={12}
							xl={12}
							className="text-center text-md-start"
						>
							<XTheme2MainTitle className="mb-2">
								{location.pathname.includes('coding-team')
									? 'Coding Team'
									: location.pathname.includes('md-advisor')
									? 'MD Advisor'
									: 'Case Submission'}
							</XTheme2MainTitle>
							{location.pathname.includes('coding-team') ||
							location.pathname.includes('md-advisor') ? (
								<></>
							) : (
								<XTheme2Para1>
									Oversee and handle healthcare cases
									effectively.
								</XTheme2Para1>
							)}
						</Col>
						<Col
							xs={24}
							sm={24}
							md={12}
							lg={12}
							xl={12}
							className="text-center text-md-end"
						>
							{checkModulePermissions(
								'case-filing',
							).sub_modules.includes('add-case') ? (
								isMobile ? (
									<XTheme2Button
										shape="circle"
										size="large"
										className="noBackground borderColor"
										onClick={() => navigate('/case/add')}
										icon={<PlusOutlined />}
									/>
								) : (
									<Link to="/case/add">
										<XTheme2Button
											size="large"
											icon={<PlusOutlined />}
										>
											Create New Case
										</XTheme2Button>
									</Link>
								)
							) : (
								<></>
							)}
						</Col>
					</Row>

					<>
						<Row gutter={(15, 15)} className="mb-3">
							<Col
								xs={24}
								sm={12}
								md={12}
								lg={6}
								className="mb-3 mb-lg-0"
							>
								<XTheme2IndividualInnerCard>
									<div className="insideCard">
										<div className="imgWrapper">
											<img
												className="img-fluid"
												src="./images/escalation.svg"
												alt=""
											/>
										</div>
										<div className="textWrapper">
											<div className="numberWrapper">
												{filingStatusCount.escalation}
												<span className="title fontSize30">
													Issues Raised
												</span>
											</div>
											<div
												className="filterButton"
												onClick={() =>
													handleClick('escalation')
												}
											>
												Review Now
											</div>
										</div>
									</div>
								</XTheme2IndividualInnerCard>
							</Col>
							<Col
								xs={24}
								sm={12}
								md={12}
								lg={6}
								className="mb-3 mb-lg-0"
							>
								<XTheme2IndividualInnerCard>
									<div className="insideCard">
										<div className="imgWrapper">
											<img
												className="img-fluid"
												src="./images/at_risk.svg"
												alt=""
											/>
										</div>
										<div className="textWrapper">
											<div className="numberWrapper">
												{filingStatusCount.at_risk}
												<span className="title fontSize30">
													At Risk
												</span>
											</div>
											<div
												className="filterButton"
												onClick={() =>
													handleClick('at_risk')
												}
											>
												Mitigate
											</div>
										</div>
									</div>
								</XTheme2IndividualInnerCard>
							</Col>
							<Col
								xs={24}
								sm={12}
								md={12}
								lg={6}
								className="mb-3 mb-md-0"
							>
								<XTheme2IndividualInnerCard>
									<div className="insideCard">
										<div className="imgWrapper">
											<img
												className="img-fluid"
												src="./images/in_process.svg"
												alt=""
											/>
										</div>
										<div className="textWrapper">
											<div className="numberWrapper">
												{filingStatusCount.in_process}
												<span className="title fontSize30">
													Ongoing
												</span>
											</div>
											<div
												className="filterButton"
												onClick={() =>
													handleClick('in_process')
												}
											>
												Check
											</div>
										</div>
									</div>
								</XTheme2IndividualInnerCard>
							</Col>
							<Col xs={24} sm={12} md={12} lg={6}>
								<XTheme2IndividualInnerCard>
									<div className="insideCard">
										<div className="imgWrapper">
											<img
												className="img-fluid"
												src="./images/timer.svg"
												alt=""
											/>
										</div>
										<div className="textWrapper">
											<div className="numberWrapper">
												{filingStatusCount.untimely}
												<span className="title fontSize30">
													Untimely
												</span>
											</div>
											<div
												className="filterButton"
												onClick={() =>
													handleClick('untimely')
												}
											>
												Resubmit
											</div>
										</div>
									</div>
								</XTheme2IndividualInnerCard>
							</Col>
						</Row>
					</>

					<XTheme2CustomTabsTable
						type="card"
						className="child-tabs"
						activeKey={activeTab}
						onChange={onChange}
						tabBarExtraContent={
							{
								/* <Row
												gutter={(15, 15)}
												className="align-items-center"
											>
												<Col
													xs={24}
													sm={16}
													md={12}
													lg={12}
													className="mb-3 mb-sm-0"
												>
													<Space>
														<XThemeInputText
															size="large"
															allowClear
															placeholder="Search for Cases"
															defaultValue={
																filters.patient_name
																	? filters.patient_name
																	: null
															}
															onChange={(v) => {
																if (
																	v.target
																		.value ===
																	''
																) {
																	urlPagination(
																		filters,
																		'patient_name',
																		'',
																	);
																	setFilters({
																		...filters,
																		patient_name:
																			'',
																	});
																} else {
																	setFilters({
																		...filters,
																		patient_name:
																			v
																				.target
																				.value,
																	});
																}
															}}
															onKeyDown={(e) => {
																if (
																	e.key ===
																	'Enter'
																) {
																	const searchValue =
																		filters.patient_name
																			? filters.patient_name
																			: '';
																	if (
																		searchValue
																	) {
																		urlPagination(
																			filters,
																			'patient_name',
																			searchValue,
																		);
																		setFilters(
																			{
																				...filters,
																				patient_name:
																					searchValue,
																			},
																		);
																	}
																}
															}}
														/>
													</Space>
												</Col>
												<Col
													xs={24}
													sm={8}
													md={6}
													lg={8}
													className="text-start text-md-end"
												>
													<XThemeFilterCircleButton
														shape="circle"
														size="large"
														onClick={() =>
															showDrawer()
														}
														icon={
															<img
																src="/images/theme-filter-icon.svg"
																alt="filter"
															/>
														}
													/>
												</Col>
											</Row> */
							}
						}
					>
						{items.map((item) => (
							<TabPane tab={item.label} key={item.key}>
								{activeTab === item.key && item.children}
							</TabPane>
						))}
					</XTheme2CustomTabsTable>
				</XThemeContainer>
			) : (
				<Result
					status="403"
					title="403"
					subTitle="Sorry, you are not authorized to access this page."
					extra={
						<Button type="primary" onClick={() => navigate('/')}>
							Back Home
						</Button>
					}
				/>
			)}
		</>
	);
};

const mapStateToProps = (state) => ({
	getCountByFilingAndRevenueState: state.getCountByFilingAndRevenue,
});

const mapDispatchToProps = (dispatch) => ({
	getCountByFilingAndRevenue: (data) =>
		dispatch(getCountByFilingAndRevenueApi(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(CaseManagement);
